var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-layout",class:{ 'app-layout--has-header': _vm.hasHeader, 'app-layout--has-footer': _vm.hasFooter },attrs:{"data-theme":_vm.theme}},[_c('div',{staticClass:"app-layout__wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }